"use client";

import * as React from "react";
import {
  applyThemePreference,
  isThemePreference,
  type ThemePreference,
} from "@modernatc/ui/theme";

/**
 * Adopts the signed-in user's saved theme on a device that has no local choice
 * yet (no `theme` cookie). This makes the Settings preference follow the user
 * to a fresh browser, without overriding a per-device toggle (which sets the
 * cookie). Renders nothing.
 */
export function ThemeSync({ accountPref }: { accountPref: ThemePreference }) {
  React.useEffect(() => {
    const hasCookie = /(?:^|; )theme=/.test(document.cookie);
    if (!hasCookie && isThemePreference(accountPref)) {
      applyThemePreference(accountPref);
    }
  }, [accountPref]);

  return null;
}
